interface SegmentButtonOption<T extends string | number> {
  value: T;
  label: string;
  disabled?: boolean;
  // Shown as the native tooltip, which is how a disabled option explains itself
  title?: string;
}

interface SegmentButtonProps<T extends string | number> {
  options: SegmentButtonOption<T>[];
  selected: T;
  onSelect: (value: T) => void;
}

export function SegmentButton<T extends string | number>({
  options,
  selected,
  onSelect,
}: SegmentButtonProps<T>) {
  return (
    <div className="inline-flex rounded-md border bg-muted p-0.5 gap-0.5">
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          aria-pressed={option.value === selected}
          onClick={() => onSelect(option.value)}
          disabled={option.disabled}
          title={option.title}
          className={[
            'px-3 py-1 rounded text-sm font-medium transition-colors',
            option.value === selected
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
            'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:text-muted-foreground',
          ].join(' ')}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
